var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHelzbergBlack(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlSpace: "preserve",
    viewBox: "472.11336 520.86888 136.08 45.36",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      maxHeight: 500
    },
    width: 136.08,
    height: 45.36,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Fabric.js 5.2.4")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    id: "3fe6e260-51a1-4d09-bd78-092abc734116",
    transform: "matrix(1 0 0 1 540 540)"
  }, /*#__PURE__*/React.createElement("rect", {
    height: 1080,
    width: 1080,
    ry: 0,
    rx: 0,
    y: -540,
    x: -540,
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1,
      visibility: "hidden"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "30f87090-40fe-435f-b1f4-23f51a33e960",
    transform: "matrix(1 0 0 1 540 540)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 540 540)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {}
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    height: 1080,
    width: 1080,
    ry: 0,
    rx: 0,
    y: -540,
    x: -540,
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(28,26,26)",
      fillRule: "nonzero",
      opacity: 1,
      visibility: "hidden"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 54.21 0.02)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "M 117.957 7.87992 L 117.957 8.22519 L 118.018 8.26066 C 118.472 8.52079 118.751 8.69106 118.926 8.937 C 119.096 9.18058 119.179 9.51402 119.179 10.136 L 119.179 11.893 C 118.368 12.9714 117.238 13.4254 115.894 13.4254 C 114.393 13.4254 113.139 12.8792 112.262 11.9001 C 111.382 10.9187 110.872 9.49274 110.872 7.71675 C 110.872 5.94076 111.38 4.45329 112.248 3.41513 C 113.116 2.37933 114.348 1.77867 115.816 1.77867 C 117.843 1.77867 119.068 3.09824 120.151 4.88132 L 120.187 4.94044 L 120.53 4.94044 L 120.53 0.716858 L 120.222 0.716858 L 119.229 1.72664 C 118.427 1.16854 117.231 0.716858 115.717 0.716858 C 111.631 0.716858 108.639 3.68945 108.639 7.77587 C 108.639 9.81435 109.356 11.543 110.567 12.7609 C 111.777 13.9788 113.478 14.6812 115.431 14.6812 C 116.389 14.6812 117.793 14.2555 118.945 13.8393 C 119.524 13.6288 120.045 13.4207 120.418 13.2623 C 120.605 13.1842 120.759 13.118 120.863 13.0731 C 120.915 13.0494 120.955 13.0329 120.984 13.0187 L 121.014 13.0045 L 121.026 12.9998 L 121.097 12.9667 L 121.137 10.1383 C 121.137 9.51402 121.218 9.17822 121.39 8.937 C 121.568 8.6887 121.849 8.52079 122.313 8.26066 L 122.374 8.22519 L 122.374 7.87992 L 117.954 7.87992 L 117.957 7.87992 Z",
    transform: "translate(-115.51, -7.7)",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(28,26,26)",
      fillRule: "nonzero",
      opacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -7.72 -0.06)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "M 59.1068 10.9437 C 58.4317 11.9299 57.9315 12.5762 57.345 12.9808 C 56.7657 13.3805 56.0907 13.5529 55.0423 13.5529 L 50.5158 13.5529 L 59.2552 1.06015 L 59.2552 0.82078 L 49.8527 0.82078 C 49.2854 0.82078 49.0053 0.765725 48.7205 0.708277 L 48.5888 0.681946 L 48.0909 4.46399 L 48.5122 4.46399 L 48.5481 4.40894 C 48.596 4.33473 48.6439 4.26292 48.6894 4.19351 C 49.1897 3.42752 49.5583 2.86261 50.0298 2.47243 C 50.5349 2.05832 51.1645 1.8405 52.2249 1.8405 L 56.3851 1.8405 L 47.6074 14.3308 L 47.6074 14.5702 L 58.8865 14.5702 L 59.5496 10.8887 L 59.1427 10.8887 L 59.1068 10.9414 L 59.1068 10.9437 Z",
    transform: "translate(-53.58, -7.63)",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(28,26,26)",
      fillRule: "nonzero",
      opacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 8.02 0.01)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "M 73.7402 8.26275 C 73.1894 7.84847 72.4926 7.58506 71.7215 7.46054 C 73.2302 7.08698 74.4011 5.94713 74.4011 4.35709 C 74.4011 3.07117 73.8647 2.17797 72.9643 1.61044 C 72.0711 1.05009 70.8331 0.81781 69.4347 0.81781 L 63.6755 0.81781 L 63.6755 1.16982 L 63.7402 1.20574 C 64.1976 1.45957 64.4682 1.62959 64.6358 1.87864 C 64.801 2.12528 64.8729 2.47011 64.8729 3.1023 L 64.8729 12.2857 C 64.8729 12.9179 64.801 13.2628 64.6358 13.5094 C 64.4682 13.7608 64.1976 13.9309 63.7402 14.1823 L 63.6755 14.2182 L 63.6755 14.5702 L 69.8968 14.5702 C 71.3767 14.5702 72.6387 14.2925 73.5367 13.6794 C 74.4418 13.0616 74.9615 12.1109 74.9615 10.7987 C 74.9615 9.6684 74.4945 8.82788 73.7426 8.26035 L 73.7402 8.26275 Z M 71.4845 2.43898 C 72.0137 2.85325 72.3202 3.48783 72.3202 4.39301 C 72.3202 5.41313 71.9658 6.06207 71.4126 6.45958 C 70.8499 6.86428 70.0597 7.02711 69.1641 7.02711 L 66.8772 7.02711 L 66.8772 1.81638 L 69.2048 1.81638 C 70.1746 1.81638 70.9529 2.02231 71.4869 2.43898 L 71.4845 2.43898 Z M 69.6071 13.5717 L 66.8748 13.5717 L 66.8748 8.01131 L 69.3365 8.01131 C 70.4524 8.01131 71.3384 8.22204 71.9418 8.66744 C 72.5381 9.10805 72.8781 9.79053 72.8781 10.7819 C 72.8781 11.7733 72.5429 12.4725 71.9802 12.9155 C 71.4126 13.3609 70.5961 13.5717 69.6071 13.5717 Z",
    transform: "translate(-69.32, -7.69)",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(28,26,26)",
      fillRule: "nonzero",
      opacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 22.77 -0.06)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "M 89.3264 11.08 C 88.6992 12.016 88.2157 12.6336 87.6316 13.0214 C 87.0547 13.4044 86.3677 13.572 85.3192 13.572 L 81.6231 13.572 L 81.6231 8.01353 L 84.2778 8.01353 C 85.0654 8.01353 85.4819 8.05661 85.7883 8.27924 C 86.0995 8.50426 86.3198 8.93036 86.6501 9.78496 L 86.6812 9.86396 L 87.0643 9.86396 L 87.0643 5.16008 L 86.6812 5.16008 L 86.6501 5.23907 C 86.3198 6.0841 86.0995 6.5102 85.7883 6.74001 C 85.4819 6.96503 85.0654 7.0129 84.2778 7.0129 L 81.6231 7.0129 L 81.6231 1.82068 L 84.8739 1.82068 C 85.9583 1.82068 86.6118 2.00022 87.148 2.34972 C 87.6436 2.67288 88.0457 3.14447 88.5915 3.78602 C 88.6442 3.84826 88.6992 3.9105 88.7543 3.97513 L 88.7926 4.01822 L 89.1565 4.01822 L 88.4455 0.681213 L 88.3234 0.705152 C 88.0385 0.762604 87.7585 0.817662 87.1911 0.817662 L 78.4058 0.817662 L 78.4058 1.16956 L 78.4704 1.20546 C 78.9276 1.45921 79.2053 1.62917 79.3753 1.88052 C 79.5428 2.12709 79.6218 2.4718 79.6218 3.10377 L 79.6218 12.2841 C 79.6218 12.9137 79.5452 13.2584 79.3753 13.5074 C 79.2029 13.7587 78.9276 13.9287 78.4704 14.1824 L 78.4058 14.2183 L 78.4058 14.5702 L 89.0679 14.5702 L 89.731 11.025 L 89.3623 11.025 L 89.3264 11.08 Z",
    transform: "translate(-84.07, -7.63)",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(28,26,26)",
      fillRule: "nonzero",
      opacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -22.18 0.01)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "M 44.2013 10.6348 C 43.4856 11.7647 42.9661 12.4924 42.37 12.9424 C 41.7812 13.3853 41.1085 13.5672 40.0624 13.5672 L 36.8499 13.5672 L 36.8499 3.1015 C 36.8499 2.47193 36.9313 2.12722 37.1037 1.88066 C 37.2784 1.62931 37.5609 1.45696 38.0181 1.20561 L 38.0827 1.1697 L 38.0827 0.81781 L 33.6302 0.81781 L 33.6302 1.1697 L 33.6949 1.20561 C 34.1521 1.45935 34.4298 1.62931 34.5997 1.88066 C 34.7673 2.12722 34.8463 2.47193 34.8463 3.1039 L 34.8463 12.2841 C 34.8463 12.9137 34.7697 13.2584 34.5997 13.5074 C 34.4274 13.7587 34.1521 13.9287 33.6949 14.1824 L 33.6302 14.2183 L 33.6302 14.5702 L 43.847 14.5702 L 44.6082 10.5798 L 44.2372 10.5798 L 44.2013 10.6372 L 44.2013 10.6348 Z",
    transform: "translate(-39.12, -7.69)",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(28,26,26)",
      fillRule: "nonzero",
      opacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 38.81 0.02)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "M 106.621 14.1765 C 106.056 13.9466 105.639 13.7311 105.306 13.4127 C 104.976 13.0966 104.719 12.668 104.492 11.9927 L 103.934 10.3717 C 103.699 9.65336 103.364 9.06911 102.864 8.63572 C 102.514 8.33401 102.086 8.11373 101.564 7.97485 C 102.323 7.87428 103.048 7.62765 103.63 7.20383 C 104.411 6.63634 104.925 5.75518 104.925 4.51007 C 104.925 3.1548 104.339 2.22336 103.391 1.63671 C 102.452 1.05486 101.166 0.81781 99.7653 0.81781 L 93.5254 0.81781 L 93.5254 1.1698 L 93.59 1.20571 C 94.0474 1.45952 94.3251 1.62953 94.4951 1.88095 C 94.6628 2.12758 94.7418 2.47238 94.7418 3.10452 L 94.7418 12.2873 C 94.7418 12.3591 94.7418 12.4238 94.7394 12.4884 C 94.7394 12.4788 94.7394 12.4668 94.7394 12.4573 C 94.7394 12.4692 94.7394 12.4788 94.7394 12.4884 C 94.7394 12.51 94.7394 12.5291 94.737 12.5483 C 94.737 12.5698 94.737 12.5914 94.7346 12.6105 C 94.7346 12.6321 94.7322 12.6512 94.7298 12.6728 C 94.7298 12.6943 94.7274 12.7159 94.725 12.735 C 94.725 12.7422 94.725 12.747 94.725 12.7542 C 94.7202 12.7997 94.7154 12.8428 94.7106 12.8859 C 94.7154 12.8452 94.7202 12.7997 94.725 12.7542 C 94.725 12.747 94.725 12.7422 94.725 12.735 C 94.6963 13.0822 94.6221 13.3193 94.4975 13.506 C 94.4975 13.506 94.4975 13.506 94.4975 13.5084 C 94.3204 13.7718 94.033 13.937 93.6068 14.1741 C 93.6834 14.131 93.7529 14.0927 93.8199 14.052 C 93.7529 14.0903 93.681 14.131 93.6044 14.1741 C 93.5924 14.1813 93.5805 14.1885 93.5661 14.1956 C 93.5541 14.2028 93.5398 14.21 93.5278 14.2172 L 93.5541 14.2028 C 93.5541 14.2028 93.5374 14.2124 93.5278 14.2172 L 93.5278 14.5692 L 97.9815 14.5692 L 97.9815 14.2172 L 97.9168 14.1813 C 97.4571 13.9275 97.1769 13.7575 97.0021 13.506 C 96.8297 13.2594 96.7483 12.9146 96.7483 12.2849 L 96.7483 8.41543 L 99.1524 8.41543 C 100.053 8.41543 100.608 8.59501 101.001 8.93742 C 101.398 9.28222 101.65 9.809 101.911 10.5513 C 101.953 10.6854 101.96 10.6848 101.911 10.5513 L 102.548 12.4022 C 102.883 13.348 103.302 13.8389 103.685 14.131 C 103.905 14.289 104.202 14.392 104.511 14.459 C 104.822 14.5261 105.155 14.562 105.462 14.5764 C 105.768 14.5931 106.048 14.5907 106.252 14.5836 C 106.252 14.5836 106.701 14.5596 106.697 14.5596 L 106.697 14.2076 L 106.621 14.1765 Z M 101.791 6.78719 C 101.195 7.22538 100.366 7.39778 99.4517 7.39778 L 96.7388 7.39778 L 96.7388 1.8163 L 99.4517 1.8163 C 100.45 1.8163 101.279 2.01743 101.853 2.45083 C 102.423 2.87944 102.761 3.54749 102.761 4.52922 C 102.761 5.64504 102.378 6.3514 101.789 6.7848 L 101.791 6.78719 Z",
    transform: "translate(-100.11, -7.7)",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(28,26,26)",
      fillRule: "nonzero",
      opacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -37.35 -0.05)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "M 29.1954 11.0816 C 28.5694 12.0172 28.0843 12.6345 27.5037 13.0221 C 26.9278 13.405 26.242 13.5725 25.1954 13.5725 L 21.506 13.5725 L 21.506 8.01642 L 24.156 8.01642 C 24.9421 8.01642 25.3579 8.05949 25.6637 8.28202 C 25.9744 8.50694 26.1942 8.93286 26.524 9.78709 L 26.555 9.86605 L 26.9373 9.86605 L 26.9373 5.16422 L 26.555 5.16422 L 26.524 5.24318 C 26.1942 6.08784 25.9744 6.51375 25.6637 6.74346 C 25.3579 6.96838 24.9421 7.01624 24.156 7.01624 L 21.506 7.01624 L 21.506 1.82628 L 24.751 1.82628 C 25.8334 1.82628 26.4857 2.00574 27.021 2.35509 C 27.5156 2.67812 27.917 3.14949 28.4618 3.79076 C 28.5144 3.85297 28.5694 3.91519 28.6243 3.97979 L 28.6602 4.02286 L 29.0234 4.02286 L 28.3161 0.687317 L 28.1942 0.711245 C 27.9099 0.768672 27.6303 0.823706 27.064 0.823706 L 18.2946 0.823706 L 18.2946 1.17545 L 18.3591 1.21134 C 18.8155 1.46497 19.0926 1.63486 19.2623 1.8861 C 19.4296 2.13256 19.5084 2.47712 19.5084 3.10882 L 19.5084 12.2852 C 19.5084 12.9145 19.432 13.259 19.2623 13.5079 C 19.0926 13.7591 18.8155 13.929 18.3591 14.1826 L 18.2946 14.2185 L 18.2946 14.5703 L 28.9374 14.5703 L 29.5992 11.0265 L 29.2313 11.0265 L 29.1954 11.0816 Z",
    transform: "translate(-23.95, -7.63)",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(28,26,26)",
      fillRule: "nonzero",
      opacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -54 0.01)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "M 9.96286 1.16724 L 10.0268 1.20315 C 10.4795 1.45685 10.7544 1.62678 10.9226 1.87808 C 11.0885 2.1246 11.1667 2.46925 11.1667 3.1011 L 11.1667 6.98797 L 3.41036 6.98797 L 3.41036 3.1011 C 3.41036 2.47164 3.49093 2.12699 3.66392 1.88048 C 3.83929 1.62917 4.11656 1.45685 4.56919 1.20554 L 4.63317 1.16964 L 4.63317 0.81781 L 0.225342 0.81781 L 0.225342 1.16964 L 0.289326 1.20554 C 0.741959 1.45924 1.01686 1.62917 1.18511 1.88048 C 1.351 2.12699 1.4292 2.47164 1.4292 3.1035 L 1.4292 12.2821 C 1.4292 12.9116 1.35337 13.2563 1.18511 13.5052 C 1.01686 13.7565 0.741959 13.9264 0.289326 14.1801 L 0.225342 14.216 L 0.225342 14.5678 L 4.63317 14.5678 L 4.63317 14.216 L 4.56919 14.1801 C 4.11656 13.9264 3.83692 13.7565 3.66392 13.5052 C 3.4933 13.2587 3.41036 12.914 3.41036 12.2845 L 3.41036 8.03149 L 11.1667 8.03149 L 11.1667 12.2845 C 11.1667 12.914 11.0909 13.2587 10.9226 13.5076 C 10.7544 13.7589 10.4795 13.9288 10.0268 14.1825 L 9.96286 14.2184 L 9.96286 14.5702 L 14.3707 14.5702 L 14.3707 14.2184 L 14.3067 14.1825 C 13.8541 13.9288 13.5744 13.7589 13.4014 13.5076 C 13.2308 13.261 13.1479 12.9164 13.1479 12.2869 L 13.1479 3.1011 C 13.1479 2.47164 13.2284 2.12699 13.4014 1.88048 C 13.5768 1.62917 13.8541 1.45685 14.3067 1.20554 L 14.3707 1.16964 L 14.3707 0.81781 L 9.96286 0.81781 L 9.96286 1.16964 L 9.96286 1.16724 Z",
    transform: "translate(-7.3, -7.69)",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(28,26,26)",
      fillRule: "nonzero",
      opacity: 1
    }
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(NaN NaN NaN NaN 0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {}
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(NaN NaN NaN NaN 0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {}
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelzbergBlack);
export default __webpack_public_path__ + "static/media/helzberg-black.16e25ec3ab21d8c72dfe3c0a92fa52cf.svg";
export { ForwardRef as ReactComponent };